// import Swiper from "./swiper";
// import "photoswipe";
import * as PhotoSwipe from "photoswipe";
import * as PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
// import PhotoSwipe from 'photoswipe';
// import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import "./v1/gallery";
import "./v6/gallery";
import "./v7/gallery";
import "./v8/gallery";
